/**
 * Cloud chat conversations contracts.
 * Persisted per-user in Firestore `user_conversations/{uid}/items/{id}`
 * via authenticated `/api/conversations/*` routes.
 */
export const CONVERSATION_UNTITLED = 'Nueva conversación';
export const MAX_CONVERSATIONS = 100;
export const MAX_CONVERSATION_MESSAGES = 200;
export const MAX_SEED_MESSAGES = 50;
export const MAX_MESSAGE_TEXT = 4000;
export const TITLE_SNIPPET_LENGTH = 48;
export function isValidConversationRole(role) {
    return role === 'user' || role === 'assistant' || role === 'system';
}
export function deriveConversationTitle(text) {
    const singleLine = text.replace(/\s+/g, ' ').trim();
    if (singleLine.length <= TITLE_SNIPPET_LENGTH)
        return singleLine;
    return `${singleLine.slice(0, TITLE_SNIPPET_LENGTH).trimEnd()}…`;
}
export function conversationSummaryOf(conversation) {
    return {
        id: conversation.id,
        title: conversation.title,
        createdAt: conversation.createdAt,
        updatedAt: conversation.updatedAt,
        messageCount: conversation.messages.length,
        anchor: conversation.anchor,
    };
}
//# sourceMappingURL=conversations.js.map